import { type FC } from 'react'

import { ErrorBoundary } from '../../../../error-boundary'
import { useNowGeneralContext } from '../../../../now'
import { productAccessorIsPrescriptionProduct } from '../../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { ProductBuyBoxNowInfo } from '../ProductBuyBoxNowInfo/ProductByBoxNowInfo'
import { ProductBuyBoxStockStatusAndDeliveryInfo } from '../ProductBuyBoxStockStatusAndDeliveryInfo'
import { ProductNowDeliveryBox } from '../ProductNowDeliveryBox'

export const ProductBuyBoxNowDetails: FC = () => {
  const {
    currentPrescriptionType,
    currentVariant,
    nowDetails,
    offerId,
    product,
  } = useProductPageContext()
  const { nowGeneralData } = useNowGeneralContext()

  const { isOfferMirakl } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)

  const shouldShowNowDeliveryBox =
    nowDetails.nowCustomerJourneyEnabled &&
    !isOfferMirakl &&
    !nowDetails.savedZipCode &&
    !nowGeneralData.zipSupportInfo?.zip

  const shouldShowNowInfo = !isPrescriptionProduct

  return (
    <div>
      <ProductBuyBoxStockStatusAndDeliveryInfo />

      {shouldShowNowDeliveryBox ? <ProductNowDeliveryBox /> : null}

      {shouldShowNowInfo ? (
        <ErrorBoundary>
          <ProductBuyBoxNowInfo />
        </ErrorBoundary>
      ) : null}
    </div>
  )
}
